var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      width: 56,
      transform: "rotate(0deg)",
      height: 56,
      background: "transparent"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.402 17.3a2.922 2.922 0 002.079-.86l2.998-2.999a.571.571 0 01.79 0l3.01 3.01a2.919 2.919 0 002.077.86h.592l-3.8 3.798a3.037 3.037 0 01-4.296 0L6.037 17.3h.36M17.356 6.688a2.917 2.917 0 00-2.077.862l-3.006 3.01a.56.56 0 01-.789 0L8.486 7.562a2.918 2.918 0 00-2.079-.86h-.37L9.852 2.89a3.038 3.038 0 014.296 0l3.8 3.798h-.592z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89 9.851l2.27-2.269h1.242c.545 0 1.067.216 1.454.6l2.999 2.998a1.44 1.44 0 002.038 0l3.011-3.01a2.07 2.07 0 011.454-.6h1.473l2.278 2.279a3.035 3.035 0 010 4.296l-2.279 2.28h-1.474a2.07 2.07 0 01-1.453-.6l-3.01-3.012a1.475 1.475 0 00-2.04 0L7.855 15.81a2.07 2.07 0 01-1.454.6H5.16l-2.27-2.263a3.035 3.035 0 010-4.297z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.4c4a9b32401694c25e2dbdc818034bb1.svg";
export { ForwardRef as ReactComponent };